var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tougubaogao-layer"},[_c('div',{staticClass:"tougubaogao-download"},[_c('button',{staticClass:"generate-report-btn",on:{"click":_vm.downloadReport}},[_vm._v("下载报告")])]),_c('div',{ref:"reportContainer",staticClass:"tougubaogao-container"})])
}
var staticRenderFns = []

export { render, staticRenderFns }